import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { UnstyledHeading } from "../heading";

const Title = styled(UnstyledHeading)`
  margin-block: 0.8rem 1.5rem;
  font-weight: bold;
  font-size: ${({ $fontSize }) =>
    $fontSize === "small"
      ? "1rem"
      : $fontSize === "medium"
      ? "1.25rem"
      : $fontSize === "large"
      ? "2.25rem"
      : $fontSize === "x-large"
      ? "2.625rem"
      : "1.25rem"};
  color: ${({ $textColor }) =>
    `var(--color-${$textColor}, var(--color-black))`};
  background-color: ${({ $backgroundColor }) =>
    `var(--color-${$backgroundColor}, transparent)`};
  text-align: ${({ $align }) => $align};
  font-weight: 100;
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1rem;
  }
`;

const ProductTitle = ({
  name,
  className,
  align,
  fontSize,
  headingLevel,
  textColor,
  backgroundColor,
}) => {
  return (
    <Title
      className={className}
      $fontSize={fontSize}
      level={headingLevel}
      $textColor={textColor}
      $backgroundColor={backgroundColor}
      $align={align}
    >
      {name}
    </Title>
  );
};

ProductTitle.propTypes = {
  name: PropTypes.string,
  fontSize: PropTypes.string,
  align: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  headingLevel: PropTypes.number,
  className: PropTypes.string,
};

export default ProductTitle;
